var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatUnavailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 36
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "seat-unavailable_svg__a",
    d: "M0 3.804C0 1.703 1.516 0 3.387 0H18.29c1.87 0 3.387 1.703 3.387 3.804v15.744c0 2.1-1.516 3.803-3.387 3.803H3.387C1.517 23.351 0 21.648 0 19.548V3.804z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 36,
    fill: "#FFF",
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.866 4.153)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "seat-unavailable_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#seat-unavailable_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2276E3",
    strokeWidth: 2,
    d: "M0 3.804C0 1.703 1.516 0 3.387 0H18.29c1.87 0 3.387 1.703 3.387 3.804v15.744c0 2.1-1.516 3.803-3.387 3.803H3.387C1.517 23.351 0 21.648 0 19.548V3.804h0z",
    mask: "url(#seat-unavailable_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2276E3",
    d: "M29.067 27.196v-10.22c0-.54.402-.976.898-.976h2.917c.496 0 .898.437.898.975v13.932c0 .539-.402.975-.898.975H9.577h.011-.323c-.495 0-.897-.437-.897-.975V16.974c0-.538.402-.975.897-.975h2.918c.495 0 .897.437.897.975v10.22h15.986z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.067 27.196v-10.22c0-.54.402-.976.898-.976h2.917c.496 0 .898.437.898.975v13.932c0 .539-.402.975-.898.975H9.577h.011-.323c-.495 0-.897-.437-.897-.975V16.974c0-.538.402-.975.897-.975h2.918c.495 0 .897.437.897.975v10.22h15.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2276E3",
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M34.738 5.107l2.25 2.681L8.262 31.893l-2.25-2.681z"
  }))));
}
export default SvgSeatUnavailable;